import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { Margin } from '@freelancer/ui/margin';

@Component({
  selector: 'app-user-profile-editable-ui-confirmation',
  template: `
    <fl-banner-alert
      [closeable]="false"
      [title]="title"
      [type]="BannerAlertType.WARNING"
    >
      <fl-bit class="ConfirmationContainer">
        <fl-bit [flMarginBottom]="Margin.XSMALL">
          {{ body }}
        </fl-bit>

        <fl-bit>
          <fl-button
            i18n="Confirm button"
            [flTrackingLabel]="flTrackingLabel + 'ConfirmationButton'"
            [color]="ButtonColor.SECONDARY"
            [flMarginRight]="Margin.SMALL"
            [busy]="isBusy"
            (click)="confirm.emit()"
          >
            Confirm
          </fl-button>
          <fl-link
            i18n="Cancel button"
            [flTrackingLabel]="flTrackingLabel + 'CancelButton'"
            [disabled]="isBusy"
            (click)="cancel.emit()"
          >
            Cancel
          </fl-link>
        </fl-bit>
      </fl-bit>
    </fl-banner-alert>
  `,
  styleUrls: ['./user-profile-editable-ui-confirmation.component.scss'],
})
export class UserProfileEditableUiConfirmationComponent {
  BannerAlertType = BannerAlertType;
  ButtonColor = ButtonColor;
  Margin = Margin;

  @Input() title: string;
  @Input() body: string;
  @Input() isBusy = false;
  @Input() flTrackingLabel: string;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
